import React, { useEffect } from 'react'

import { Input, SelectInput } from 'components/__new/common/form';
import Textarea from 'components/__new/common/form/Textarea';
import { WorkflowType } from 'utils/workflowType';


const EditWorkflowDetails = ({
    form,
    setForm,
    defaultForm,
    workflow
}) => {

    useEffect(() => {
        setForm(defaultForm);
        // eslint-disable-next-line
    }, [])
    
    useEffect(() => {
        setForm({
            title: workflow?.title || "",
            description: workflow?.description || "",
            type: workflow?.type || "",
        })
        // eslint-disable-next-line
    }, [workflow])


    return (
        <div className="w-full pt-4 text-[#121619] space-y-7">
            <Input
                type="text"
                label="Workflow Title"
                value={form?.title || ""}
                className="form-input"
                onChange={(e) => setForm({...form, title: e.target.value})}
                placeholder="Enter a workflow title"
            />

            <Textarea
                rows="5"
                label="Description"
                value={form?.description || ""}
                placeholder='Enter a description...'
                onChange={(e) => setForm({...form, description: e.target.value})}
                className="form-input-textarea !rounded-lg placeholder-[#9ca3af]"
            />

            <SelectInput
                label="Request Type"
                value={form?.type || ""}
                onChange={(e) => setForm({...form, type: e.target.value})}
            >
                <option value="">Select request type</option>
                <option value={WorkflowType.TRANSFER_REQUEST}>Transfer</option>
                <option value={WorkflowType.MULTIPLE_TRANSFER_REQUEST}>Multiple Transfer</option>
                <option value={WorkflowType.BULK_TRANSFER}>Bulk Transfer</option>
                <option value={WorkflowType.BILL_PAYMENT_REQUEST}>Bill Payment</option>
                <option value={WorkflowType.MULTIPLE_BILL_PAYMENT_REQUEST}>Multiple bill payment</option>
                {/* <option value={WorkflowType.PAYROLL_REQUEST}>Payroll</option>
                <option value={WorkflowType.ON_DEMAND_REQUEST}>On demand</option> */}
            </SelectInput>
        </div>
    )
}

export default EditWorkflowDetails;